module.exports = __webpack_public_path__ + "static/media/pwc_logo_white.75868695.svg";